import script from "./input-automation-steps-edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./input-automation-steps-edit.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__